/* Detección automática del tratamiento de foto (decisión Kike #4).
   En vez de un metafield manual, clasifica cada foto en el cliente mirando sus esquinas:
     - esquinas con transparencia  -> "transparente" (drop-shadow)
     - esquinas blancas puras       -> "blanco"       (multiply sobre el gris)
     - esquinas gris del estándar   -> "editada"      (fondo ya ≈ #F7F7F7: render normal;
                                       multiply lo oscurecería y se vería un recuadro)
     - resto                        -> "lifestyle"     (sin tratamiento)
   Pone el resultado en el contenedor [data-bg] (las reglas CSS ya existen).

   Robusto: usa una imagen "probe" con crossOrigin para poder leer píxeles del CDN de Shopify
   (que sí manda headers CORS). Si algo falla, deja el valor por defecto ("blanco") — nunca rompe. */
(function(){
  function classify(img){
    try {
      var w = 28, h = 28;
      var cv = document.createElement("canvas"); cv.width = w; cv.height = h;
      var ctx = cv.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data;
      var corners = [[1,1],[w-2,1],[1,h-2],[w-2,h-2]];
      var transparent = false, whites = 0, editadas = 0;
      corners.forEach(function(c){
        var i = (c[1] * w + c[0]) * 4;
        var r = d[i], g = d[i+1], b = d[i+2], a = d[i+3];
        if (a < 235) transparent = true;
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        if (mn > 252) whites++;                       // blanco puro (multiply lo funde con el frame)
        else if (mn > 238 && mx - mn < 8) editadas++; // gris plano ≈ #F7F7F7 (estándar de foto editada)
      });
      if (transparent) return "transparente";
      if (whites >= 3) return "blanco";
      if (whites + editadas >= 3) return "editada";  // fondo del color del frame: sin multiply
      return "lifestyle";
    } catch(e){ return null; }                 // canvas tainted u otro fallo → no tocar
  }

  function process(img){
    if (!img || img.dataset._bgDone || !img.getAttribute("src")) return;
    img.dataset._bgDone = "1";
    var host = img.closest("[data-bg]"); if (!host) return;
    var probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.onload = function(){ var c = classify(probe); if (c) host.setAttribute("data-bg", c); };
    probe.onerror = function(){};
    probe.src = img.currentSrc || img.src;
  }

  function scan(root){
    (root || document).querySelectorAll("[data-bg] img").forEach(process);
  }

  document.addEventListener("DOMContentLoaded", function(){
    scan();
    // las cards/galería se inyectan por JS tras cargar el catálogo: observar y procesar las nuevas
    try {
      var mo = new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(); break; }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch(e){}
  });
  document.addEventListener("catalog:ready", function(){ setTimeout(scan, 60); });
})();
